(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gh-category-bento"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBento(root) {
    var grid = root.querySelector('.gh-bento');
    if (!grid || grid.hasAttribute('data-reveal')) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;

    grid.setAttribute('data-reveal', '');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
    );

    grid.querySelectorAll('.gh-bento__tile').forEach(function (tile) {
      observer.observe(tile);
    });
  }

  function initAll() {
    document.querySelectorAll('.gh-bento-wrap').forEach(initBento);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initBento(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-category-pastel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCat(root) {
    var grid = root.querySelector('.gh-cat');
    if (!grid || grid.hasAttribute('data-reveal')) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (!('IntersectionObserver' in window)) return;

    grid.setAttribute('data-reveal', '');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
    );

    grid.querySelectorAll('.gh-cat__tile').forEach(function (tile) {
      observer.observe(tile);
    });
  }

  function initAll() {
    document.querySelectorAll('.gh-cat-wrap').forEach(initCat);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCat(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-featured-product"] && !Shopify.designMode) return;
  try {
    
class GhFeaturedProduct {
  constructor(root) {
    this.root = root;
    this.main = root.querySelector('[data-gh-main]');
    this.select = root.querySelector('select[data-gh-variant]');
    this.price = root.querySelector('[data-gh-price]');
    this.compare = root.querySelector('[data-gh-compare]');
    this.chip = root.querySelector('[data-gh-chip]');
    this.button = root.querySelector('[data-gh-add]');
    this.buttonText = root.querySelector('[data-gh-add-text]');
    this.bindThumbs();
    this.bindVariants();
  }

  bindThumbs() {
    const thumbs = this.root.querySelectorAll('[data-gh-thumb]');
    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!this.main) return;
        this.main.removeAttribute('srcset');
        this.main.src = thumb.dataset.src;
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  bindVariants() {
    if (!this.select) return;
    this.select.addEventListener('change', () => {
      const option = this.select.options[this.select.selectedIndex];
      if (this.price) this.price.textContent = option.dataset.price || '';

      if (this.compare) {
        if (option.dataset.compare) {
          this.compare.textContent = option.dataset.compare;
          this.compare.classList.remove('gh-fp__was--hidden');
        } else {
          this.compare.textContent = '';
          this.compare.classList.add('gh-fp__was--hidden');
        }
      }

      if (this.chip) {
        if (option.dataset.saved) {
          this.chip.textContent = 'Save ' + option.dataset.saved + '%';
          this.chip.hidden = false;
        } else {
          this.chip.hidden = true;
        }
      }

      const available = option.dataset.available === 'true';
      if (this.button) this.button.disabled = !available;
      if (this.buttonText && !available) this.buttonText.textContent = 'Sold out';
    });
  }
}

function ghFeaturedProductInit() {
  document.querySelectorAll('.gh-fp').forEach((root) => {
    if (root.dataset.ghInit === 'true') return;
    root.dataset.ghInit = 'true';
    new GhFeaturedProduct(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ghFeaturedProductInit);
} else {
  ghFeaturedProductInit();
}

document.addEventListener('shopify:section:load', ghFeaturedProductInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gh-tabbed-products"] && !Shopify.designMode) return;
  try {
    
class GhTabbedProducts {
  constructor(root) {
    this.root = root;
    this.tabs = Array.from(root.querySelectorAll('[data-ghtp-tab]'));
    this.panels = Array.from(root.querySelectorAll('[data-ghtp-panel]'));
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => this.onKey(event, index));
    });
  }

  select(index) {
    this.tabs.forEach((tab, i) => {
      const active = i === index;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
      tab.tabIndex = active ? 0 : -1;
    });
    this.panels.forEach((panel, i) => {
      panel.hidden = i !== index;
    });
  }

  onKey(event, index) {
    let next = null;
    if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
    if (next === null) return;
    event.preventDefault();
    this.select(next);
    this.tabs[next].focus();
  }
}

function ghTabbedProductsInit() {
  document.querySelectorAll('.ghtp').forEach((root) => {
    if (root.dataset.ghtpInit === 'true') return;
    root.dataset.ghtpInit = 'true';
    new GhTabbedProducts(root);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ghTabbedProductsInit);
} else {
  ghTabbedProductsInit();
}

document.addEventListener('shopify:section:load', ghTabbedProductsInit);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newcategory"] && !Shopify.designMode) return;
  try {
    
class GhCategoryRail extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-gh-track]');
    this.prev = this.querySelector('[data-gh-prev]');
    this.next = this.querySelector('[data-gh-next]');
    if (!this.track) return;
    if (!this.classList.contains('gh-cat--slider')) return;

    this.sync = this.sync.bind(this);

    if (this.prev) {
      this.prev.hidden = false;
      this.prev.addEventListener('click', () => this.page(-1));
    }
    if (this.next) {
      this.next.hidden = false;
      this.next.addEventListener('click', () => this.page(1));
    }

    this.track.addEventListener('scroll', this.sync, { passive: true });
    this.observer = new ResizeObserver(this.sync);
    this.observer.observe(this.track);
    this.sync();
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.track) this.track.removeEventListener('scroll', this.sync);
  }

  page(direction) {
    const item = this.track.querySelector('.gh-cat__item');
    if (!item) return;
    const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
    this.track.scrollBy({ left: direction * (item.offsetWidth + gap) * 2, behavior: 'smooth' });
  }

  sync() {
    const max = this.track.scrollWidth - this.track.clientWidth;
    const x = this.track.scrollLeft;
    const scrollable = max > 4;
    if (this.prev) this.prev.disabled = !scrollable || x <= 2;
    if (this.next) this.next.disabled = !scrollable || x >= max - 2;
  }
}

if (!customElements.get('gh-category-rail')) {
  customElements.define('gh-category-rail', GhCategoryRail);
}

  } catch(e) { console.error(e); }
})();
})();
